import { render, staticRenderFns } from "./CommonCode.vue?vue&type=template&id=70231585&scoped=true"
import script from "./CommonCode.vue?vue&type=script&lang=js"
export * from "./CommonCode.vue?vue&type=script&lang=js"
import style0 from "./CommonCode.vue?vue&type=style&index=0&id=70231585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70231585",
  null
  
)

export default component.exports